import script from "./FinanceMonitoring.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceMonitoring.vue?vue&type=script&setup=true&lang=js"

import "./FinanceMonitoring.vue?vue&type=style&index=0&id=5bec87d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bec87d6"]])

export default __exports__